document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-support-form]');
  if (!form) return;

  var quantity = form.querySelector('[data-quantity]');
  var custom = form.querySelector('[data-custom-amount]');
  var variant = form.querySelector('input[name="id"]');
  var buttons = form.querySelectorAll('[data-amount]');

  function track(name, amount) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      support_amount: Number(amount),
      currency: 'USD'
    });
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', name, {
        value: Number(amount),
        currency: 'USD'
      });
    }
  }

  function setAmount(value, shouldTrack) {
    var amount = Math.max(1, Math.floor(Number(value) || 1));
    quantity.value = amount;
    custom.value = amount;
    buttons.forEach(function (button) {
      var active = Number(button.dataset.amount) === amount;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (shouldTrack) track('donation_amount_selected', amount);
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      setAmount(button.dataset.amount, true);
    });
  });

  custom.addEventListener('change', function () {
    setAmount(custom.value, true);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    setAmount(custom.value, false);
    track('begin_checkout', quantity.value);

    var buttonText = form.querySelector('.support-button span');
    if (buttonText) buttonText.textContent = 'OPENING CHECKOUT…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var checkoutUrl = root + 'cart/' + encodeURIComponent(variant.value) + ':' + encodeURIComponent(quantity.value) + '?checkout';
    window.location.assign(checkoutUrl);
  });
});
